import { createFileRoute, Outlet } from '@tanstack/react-router';

// ENG-871 Operating Costs: Overheads / Support / Value-adding baselines and
// the Support Log, factory-first. The Cost to Produce reports view joins this
// section when its spec lands. Plain-string crumbs are enough until a child
// editor route needs `?factory=` threaded (see routes/shift-patterns/route.tsx
// for that resolver pattern).
export const Route = createFileRoute('/operating-costs')({
  staticData: {
    section: 'Operating Costs',
    breadcrumb: 'Operating Costs',
  },
  component: Outlet,
});
